var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsDownicon = function SvgThumbsDownicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.332 8.56-.657-5.25a1.532 1.532 0 0 0-1.519-1.341H1.75A1.094 1.094 0 0 0 .656 3.062v4.813A1.094 1.094 0 0 0 1.75 8.969h2.22l2.006 4.012a.657.657 0 0 0 .587.363 2.41 2.41 0 0 0 2.406-2.406v-.657h2.844a1.53 1.53 0 0 0 1.519-1.72Zm-9.613-.904h-1.75V3.281h1.75v4.375Zm8.258 1.239a.22.22 0 0 1-.165.074h-3.5a.656.656 0 0 0-.656.656v1.313a1.094 1.094 0 0 1-.72 1.028L5.03 8.158V3.28h6.125a.219.219 0 0 1 .219.192l.656 5.25a.217.217 0 0 1-.054.172Z"
  })));
};
export default SvgThumbsDownicon;